import { Tracking } from '@gjensidige/core-analytics';

const isDev =
  window.location.host !== 'beta.gjensidige.se' &&
  window.location.host !== 'gjensidige.se';

const tracker = new Tracking({
  application_module: isDev ? 'web_widgets' : '',
  application_name: isDev ? 'webshop-car-widget' : '',
  application_partner: '',
  application_version: '',
  business_area: '',
  customer_segment: '',
  page_pathname: '',
  page_title: '',
  scenario_name: '',
  scenario_step: ''
});

export default tracker;
